/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffMessage } from './StaffMessage';
import {
    StaffMessageFromJSON,
    StaffMessageFromJSONTyped,
    StaffMessageToJSON,
    StaffMessageToJSONTyped,
} from './StaffMessage';

/**
 * 
 * @export
 * @interface StaffMessagePage
 */
export interface StaffMessagePage {
    /**
     * 
     */
    messages: Array<StaffMessage>;
    /**
     * 
     */
    has_more: boolean;
}

/**
 * Check if a given object implements the StaffMessagePage interface.
 */
export function instanceOfStaffMessagePage(value: object): value is StaffMessagePage {
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('has_more' in value) || value['has_more'] === undefined) return false;
    return true;
}

export function StaffMessagePageFromJSON(json: any): StaffMessagePage {
    return StaffMessagePageFromJSONTyped(json, false);
}

export function StaffMessagePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffMessagePage {
    if (json == null) {
        return json;
    }
    return {
        
        'messages': ((json['messages'] as Array<any>).map(StaffMessageFromJSON)),
        'has_more': json['has_more'],
    };
}

export function StaffMessagePageToJSON(json: any): StaffMessagePage {
    return StaffMessagePageToJSONTyped(json, false);
}

export function StaffMessagePageToJSONTyped(value?: StaffMessagePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messages': ((value['messages'] as Array<any>).map(StaffMessageToJSON)),
        'has_more': value['has_more'],
    };
}

